import React, { useEffect, useState } from "react";
import "./Search.css";
import { BiSearchAlt } from "react-icons/bi";
import { TiArrowUnsorted } from "react-icons/ti";
import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useLibrary } from "../context/LibraryContext";

const Search = ({
  ready,
  placeholder,
  onSearch,
  query = "",
  libraryId,
  showPagination,
  limit,
  setLimit,
  isSHE = false,
}) => {
  const { keyword, setKeyword } = useLibrary();
  const [searchQuery, setSearchQuery] = useState(query);
  const [offset, setOffset] = useState(0);

  const [selectedAttribute, setSelectedAttribute] = useState();
  useEffect(() => {
    setSearchQuery(query);    
  }, [query]);

  const handleSearchType = (e) => {
    const newKeyword = e.target.value;
    setKeyword(newKeyword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOffset(0);
    const normalizedKeyword = keyword.toLowerCase();
    if (onSearch) {
      onSearch({
        searchQuery,
        limit,
        keyword: normalizedKeyword,
        offset: 0,
        library: libraryId,
        attribute: selectedAttribute,
      });
    }
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
  };

  const handleAttributeChange = (event) => {    
    const newAttribute = event.target.value;
    setSelectedAttribute(newAttribute);
    onSearch({
      searchQuery,
      limit,
      keyword: keyword.toLowerCase(),
      offset,
      library: libraryId,
      attribute: newAttribute,
    });
  };

  const renderAttributeButtons = () => {
    if ([11, 12].includes(libraryId)) {
      return (
        <RadioGroup
          row
          value={selectedAttribute}
          onChange={handleAttributeChange}
          aria-label="attribute-options"
          name="attribute-options"
          style={{ marginLeft: "25px" }}
        >
          {[
            "By-Laws",
            "Declaration",
            "Orders",
            "Regulations",
            "Rules",
            "Statute",
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", color: "gray" }}
                >
                  {option}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      );
    } else {
      return (
        <RadioGroup
          row
          value={selectedAttribute}
          onChange={handleAttributeChange}
          aria-label="attribute-options"
          name="attribute-options"
          style={{ marginLeft: "25px" }}
        >
          {[
            "Peraturan",
            "Pengisytiharan",
            "Perintah",
            "Kaedah",
            "Undang-Undang Kecil",
            "Statut",
          ].map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", color: "gray" }}
                >
                  {option}
                </Typography>
              }
            />
          ))}
        </RadioGroup>
      );
    }
  };

  return (
    <>
      <div className="search-container">
        <div>
          <div className="search-select-container">
            <select value={limit} onChange={handleLimitChange}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
          <span className="search-select-text">records per page</span>
        </div>
        {ready && (
          <div className="search-select-container search-dropdown">
            <select value={keyword} onChange={handleSearchType}>
              {!isSHE && (
                <>
                  <option value="Keyword">Keyword</option>
                  <option value="No">Act No</option>
                  <option value="Year">Year</option>
                </>
              )}
              <option value="Title">Title</option>
              <option value="Category">Category</option>
            </select>

            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
        )}
        <form className="search-box" onSubmit={handleSubmit}>
          <input
            type="text"
            name="search"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>
            <BiSearchAlt size={16} style={{ transform: "scaleX(-1)" }} />
            Search
          </button>
        </form>
      </div>
      {[11, 12, 13, 14].includes(libraryId) && renderAttributeButtons()}
    </>
  );
};

export default Search;
